import { render, staticRenderFns } from "./LeagueRankings.vue?vue&type=template&id=0d709754&scoped=true"
import script from "./LeagueRankings.vue?vue&type=script&lang=js"
export * from "./LeagueRankings.vue?vue&type=script&lang=js"
import style0 from "./LeagueRankings.vue?vue&type=style&index=0&id=0d709754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d709754",
  null
  
)

export default component.exports